<template>
  <div id="claims-documents-dynamic-edit">

    <vs-alert color="danger" title="Dynamic Document Not Found" :active.sync="not_found">
      <span>Dynamic Document record with id: {{ id }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'claims-dynamic.list'}" class="text-inherit underline">All
        Dynamic Documents</router-link>
      </span>
    </vs-alert>

    <dynamic-form v-if="model" v-model="model" ref="form" :forms="formReferences" :apiModel="apiModel"/>

    <div class="vx-row" v-if="model">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              :disabled="loading"
              @click="$router.push({ name: 'claims-dynamic.list' })"
              class="ml-4 mt-2"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="loading"
              @click="save"
              class="ml-auto mt-2"
              color="light"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DynamicForm from "@/views/pages/claims-documents/dynamic/DynamicForm";
import ProductDocumentEditMixin from "@/components/mixins/ProductDocumentEditMixin";

export default {
  name: "DynamicEdit",
  components: {
    DynamicForm
  },
  mixins: [ProductDocumentEditMixin],
  data() {
    return {
      apiModel: 'dynamicClaims',
    };
  },
};
</script>

<style scoped>

</style>
